export default {
	gsmaterials: {
		app: {
			scrollTop: {
				offset: 250,
				size: 'md',
				icon: 'i-mdi-chevron-up',
				class: 'z-20'
			},
		},
	},
	ui: {
		button: {
			base: 'font-overpass [&_span]:m-auto [&_span]:font-light [&_span]:text-[18px] md:[&_span]:text-[20px] lg:[&_span]:text-[22px] xl:[&_span]:text-[24px] w-full rounded-full border-2 px-6 lg:px-8 py-4 cursor-pointer transition duration-300 ease-in-out',

			defaultVariants: {
				size: '2xl',
				color: 'primary',
				variant: 'solid'
			},
			compoundVariants: [
				{
					color: 'primary',
					variant: 'solid',
					class: '2xs:w-auto 2xs:inline-block border-red bg-red [&>span]:text-white hover:border-green hover:bg-green'
				},
				{
					color: 'secondary',
					variant: 'outline',
					class: '[&_span]:text-black hover:[&_span]:text-white border-black hover:border-red bg-white hover:bg-red'
				},
				{
					color: 'secondary',
					variant: 'solid',
					class: '[&_span]:text-white border-red bg-red'
				},
				{
					color: 'neutral',
					variant: 'solid',
					class: 'w-auto! p-3! my-auto aspect-square mr-4 bg-gray-200 hover:bg-accent hover:[&_span]:text-white '
				},
			]
		},
		formField: {
			slots: {
				labelWrapper: 'leading-6',
        		label: 'mb-0 text-gray text-[1rem] md:text-[1.25rem] font-medium'
      		}
		},
		input: {
			defaultVariants: {
				size: 'xl',
				color: 'accent',
				variant: 'outline',
			},
			compoundVariants: [
				{
					color: 'accent',
					variant: 'outline',
					class: 'ring-gray/50'
				}
		  	]
		},
		select: {
			defaultVariants: {
				size: 'xl',
				color: 'accent',
				variant: 'outline',
			},
			slots: {
   				base: 'w-full h-10 **:text-[1rem] md:**:text-[1.25rem]',
				content: 'h-auto'
  			},
			compoundVariants: [
				{
					color: 'accent',
					variant: 'outline',
					class: 'ring-gray/50'
				}
		  	]
		},
		checkbox: {
			slots: {
				base: 'cursor-pointer',
				label: '[&_span]:font-normal [&_span]:text-[1rem]! md:[&_span]:text-[1.25rem]! p-3! cursor-pointer',
				container: 'flex items-start'
			},
			defaultVariants: {
				size: 'xl',
				color: 'accent',
				variant: 'list',
				indicator: 'start'
			}
		},
		textarea: {
			defaultVariants: {
				size: 'xl',
				color: 'accent'
			},
			compoundVariants: [
				{
					color: 'accent',
					variant: 'outline',
					class: 'ring-gray/50'
				}
		  	]
		},
		pagination: {
			base: 'rounded-sm! [&_span]:font-light [&_span]:text-[1rem]! md:[&_span]:text-[1.25rem]!',
			slots: {
				list: 'gap-1.5',
				item: 'px-4! md:px-5! border-0 h-11.5 shadow-none hover:bg-accent hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-accent',
				prev: 'px-4! md:px-5! border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				next: 'px-4! md:px-5! border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				first: 'px-4! md:px-5! border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				last: 'px-4! md:px-5! border-0 h-11.5 shadow-none [&_.iconify]:mr-0 disabled:[&_.iconify]:text-gray-300 hover:bg-primary hover:[&_span]:text-white ring-gray-300 ring-1 hover:ring-primary disabled:hover:ring-gray-300',
				label: 'min-w-auto'
			}
		}
	}
}
